import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const options = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  },
  info: {
    accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    trustKey: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    agentID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  },
  loader_config: {
    accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    trustKey: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    agentID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
  },
  features: [JSErrors],
};

// The agent loader code executes immediately on instantiation.
export function configureNewRelic() {
  return new BrowserAgent(options);
}
